export default __webpack_public_path__ + "static/media/fdm.3ad88a84.jpg";